import { TFormDataEmpresa } from "../types/EmpresaTypes";

export const REGEX_LEI = /^[A-Z0-9]{20}$/;

export const validateFormData = (formData: TFormDataEmpresa): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!formData.razonSocial) errors.razonSocial = 'Campo obligatorio';
  if (!formData.taxId) errors.taxId = 'Campo obligatorio';
  if (!formData.email.includes('@')) errors.email = 'Correo inválido';
  if (!formData.tomo) errors.tomo = 'Campo obligatorio';
  if (!formData.folio) errors.folio = 'Campo obligatorio';

  if (!formData.direccion.tipoVia) errors.direccionTipoVia = 'Campo obligatorio';
  if (!formData.direccion.nombreVia) errors.direccionNombreVia = 'Campo obligatorio';
  if (!formData.direccion.piso) errors.direccionPiso = 'Campo obligatorio';
  if (!formData.direccion.escalera) errors.direccionEscalera = 'Campo obligatorio';
  if (!formData.direccion.puerta) errors.direccionPuerta = 'Campo obligatorio';

  if (!formData.representantes.some(rep => rep.rol === "Titular")) {
    errors.representantes = 'Al menos uno de los representantes debe ser titular.';
  }

  if (!formData.documento) {
    errors.documento = "No existe o no se ha podido subir el documento.";
  }

  if (!formData.lei || !REGEX_LEI.test(formData.lei)) {
    errors.lei = "El Código LEI debe contener 20 carácteres alfanuméricos.";
  }

  return errors;
};
